import React, { memo, FC, MouseEvent } from 'react';
import { IImage } from '@montana/models/generated/cms.interface';
import { BackgroundImage } from '@montana/shared/background-image';
import { SvgIcon } from '@montana/shared/svg-icon';
import { useTranslations } from '@montana/containers/translations';

export interface IVideoCurtainProps {
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    thumbnail?: IImage;
    showIcon?: boolean;
}

export const VideoCurtain: FC<IVideoCurtainProps> = memo(({ thumbnail, onClick, showIcon = true }: IVideoCurtainProps): JSX.Element => {

    const translate = useTranslations();

    return (
        <div
            className={'video-curtain'}>
            <button
                className="video-curtain__button"
                type="button"
                onClick={onClick}
                aria-label={translate((t): string => t.video.play, "Afspil video")}
            >
                <BackgroundImage imageReference={thumbnail} />
                {showIcon && <SvgIcon className="video-curtain__icon" iconName="play btn" />}
            </button>
        </div >
    )
})
